"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const PlanningDone_1 = __importDefault(require("./PlanningDone"));
const PlanningInProgress_1 = __importDefault(require("./PlanningInProgress"));
const PlanningSetup_1 = __importDefault(require("./PlanningSetup"));
const PlanningUI = ({ ws, positions, calendarMultiSelect, closePlanning, setModal, setCalendarMultiSelect, createPlan, openPlanningUI, deleteCurrentPlan, afterCloseCallback, }) => {
    const currentPlan = ws?.currentPlan;
    const plannerStatus = currentPlan?.status;
    let plannerContent = react_1.default.createElement(react_1.default.Fragment, null);
    // Dismisses the planning panel, leaving the chat with the whole column. Used to close the
    // right-side sidebar the planner had to itself; that sidebar is gone.
    const closeFn = () => {
        closePlanning();
        if (afterCloseCallback)
            afterCloseCallback();
    };
    if (plannerStatus === 'process') {
        // auto-planning in progress
        plannerContent = (react_1.default.createElement(PlanningInProgress_1.default, { planCreated: currentPlan?.created, allocatedTime: currentPlan?.allocatedTime }));
    }
    else if (plannerStatus === 'done') {
        // auto-planning finished
        plannerContent = (react_1.default.createElement(PlanningDone_1.default, { openPlanningUI: openPlanningUI, setModal: setModal, setCalendarMultiSelect: setCalendarMultiSelect, ws: ws, currentPlan: currentPlan, closeFn: closeFn, deleteCurrentPlan: deleteCurrentPlan, calendarMultiSelect: calendarMultiSelect, positions: positions }));
    }
    else {
        plannerContent = (react_1.default.createElement(PlanningSetup_1.default, { createPlan: createPlan, closeFn: closeFn, deleteCurrentPlan: deleteCurrentPlan, ws: ws, positions: positions, calendarMultiSelect: calendarMultiSelect }));
    }
    return plannerContent;
};
exports.default = PlanningUI;
